// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPagination
 */
export interface IPagination {
    /**
     * 
     * @type {number}
     * @memberof IPagination
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof IPagination
     */
    page_size?: number;
}

/**
 * Check if a given object implements the IPagination interface.
 */
export function instanceOfIPagination(value: object): value is IPagination {
    return true;
}

export function IPaginationFromJSON(json: any): IPagination {
    return IPaginationFromJSONTyped(json, false);
}

export function IPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPagination {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'] == null ? undefined : json['page'],
        'page_size': json['page_size'] == null ? undefined : json['page_size'],
    };
}

export function IPaginationToJSON(json: any): IPagination {
    return IPaginationToJSONTyped(json, false);
}

export function IPaginationToJSONTyped(value?: IPagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'page_size': value['page_size'],
    };
}

